import { render, staticRenderFns } from "./SiteAuthHeader.vue?vue&type=template&id=5b00c1de&scoped=true&"
import script from "./SiteAuthHeader.vue?vue&type=script&lang=ts&"
export * from "./SiteAuthHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SiteAuthHeader.vue?vue&type=style&index=0&id=5b00c1de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00c1de",
  null
  
)

export default component.exports